var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTutorials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_859_3473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8578 15.8846V24.8537C30.8578 25.1568 30.7374 25.4475 30.5231 25.6619C30.3088 25.8762 30.0181 25.9966 29.715 25.9966H2.28641C1.98331 25.9966 1.69262 25.8762 1.47829 25.6619C1.26396 25.4475 1.14355 25.1568 1.14355 24.8537V6.56801C1.14355 6.26491 1.26396 5.97422 1.47829 5.75989C1.69262 5.54556 1.98331 5.42516 2.28641 5.42516H16.3801M13.715 25.9966L11.4293 31.7109M18.2864 25.9966L20.5721 31.7109M9.14355 31.7109H22.8578M21.715 6.42516C21.715 5.74705 21.9161 5.08417 22.2928 4.52034C22.6695 3.95652 23.205 3.51707 23.8315 3.25757C24.458 2.99807 25.1474 2.93017 25.8124 3.06246C26.4775 3.19475 27.0884 3.52129 27.5679 4.00079C28.0474 4.48028 28.374 5.0912 28.5063 5.75627C28.6385 6.42135 28.5706 7.11072 28.3111 7.73721C28.0516 8.3637 27.6122 8.89917 27.0484 9.27591C26.4845 9.65264 25.8217 9.85373 25.1436 9.85373V12.1394",
    stroke: "url(#paint0_linear_859_3473)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1437 16.8538C24.9921 16.8538 24.8468 16.7936 24.7396 16.6864C24.6325 16.5793 24.5723 16.4339 24.5723 16.2824C24.5723 16.1308 24.6325 15.9855 24.7396 15.8783C24.8468 15.7711 24.9921 15.7109 25.1437 15.7109M25.1437 16.8538C25.2952 16.8538 25.4406 16.7936 25.5478 16.6864C25.6549 16.5793 25.7151 16.4339 25.7151 16.2824C25.7151 16.1308 25.6549 15.9855 25.5478 15.8783C25.4406 15.7711 25.2952 15.7109 25.1437 15.7109",
    stroke: "url(#paint1_linear_859_3473)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_859_3473",
    x1: 4.88853,
    y1: -14.7018,
    x2: 39.1449,
    y2: -7.45317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_859_3473",
    x1: 24.7163,
    y1: 15.0065,
    x2: 26.0376,
    y2: 15.2767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0395,
    stopColor: "#240B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3D1E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#5D1C82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671382,
    stopColor: "#8319B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9428,
    stopColor: "#BC14FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_859_3473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.853516)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorials);
export default __webpack_public_path__ + "static/media/tutorials.e62808776170f9813ae4cb458c922c18.svg";
export { ForwardRef as ReactComponent };